import React from 'react';
import { motion } from 'framer-motion';
import { ScreenShell, Headline, Subtext } from '../components/ScreenShell';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import { WELCOME_HIGHLIGHTS } from '../data/quizOptions';
interface WelcomeScreenProps {
  parentName: string;
  onStart: () => void;
}
export function WelcomeScreen({
  parentName,
  onStart
}: WelcomeScreenProps) {
  const firstName = parentName.trim().split(' ')[0] || 'familia';
  return <ScreenShell center data-id="element-186" data-mp="2r33q2f720jjo">
      <p className="text-sm font-semibold uppercase tracking-[0.14em] text-violet-500" data-id="element-187" data-mp="2n070u5n0dp6r">
        Bienvenida, {firstName} 💜
      </p>

      <div className="mt-4" data-id="element-188" data-mp="30y3x10xjvtkw">
        <Headline data-id="element-189" data-mp="30xcccl5hrg9e">Ahora vamos a crear algo único para tu pequeño.</Headline>
        <Subtext data-id="element-190" data-mp="2w0vf91gbdrk6">
          Necesitamos conocer un poco mejor a tu hijo o hija para personalizar sus 5 experiencias
          de audio.
        </Subtext>
      </div>

      <ul className="mt-7 space-y-1 rounded-4xl border border-lavender-200 bg-white/90 p-5 shadow-soft" data-id="element-191" data-mp="11n4aaf8xjvv2">
        {WELCOME_HIGHLIGHTS.map((item, index) => <motion.li key={item.text} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.15 + index * 0.1,
        duration: 0.4
      }} className="flex items-center gap-3 py-2.5 text-[15px] text-ink" data-id="element-192" data-mp="1ys9o5sb9hs4g" data-mpi={index}>
            <span aria-hidden="true" className="grid h-9 w-9 place-items-center rounded-2xl bg-lavender-100" data-id="element-193" data-mp="2cnc3t75wuvug">
              {item.emoji}
            </span>
            {item.text}
          </motion.li>)}
      </ul>

      <div className="mt-8" data-id="element-194" data-mp="2rj1i0j4uu4om">
        <PrimaryButton onClick={onStart} data-id="element-195" data-mp="2rjtfy0lxcei2">Comenzar la personalización →</PrimaryButton>
      </div>
    </ScreenShell>;
}